import { Routes } from '@angular/router';
import { Path, RoutePath } from './shared/route';
import { RouteData } from 'src/app/types/route';
import { HeaderType } from './types/route';
import { emailUnsubscribeGuard } from './guards/email-unsubscribe/email-unsubscribe.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: RoutePath.getPath(Path.landing).relativePath.join('/'),
        loadComponent: () => import('./pages/landing/landing.component').then((c) => c.LandingPageComponent),
        data: {
          showHeader: true,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['about-us']).relativePath.join('/'),
        loadComponent: () => import('./pages/about-us/about-us.component').then((c) => c.AboutUsPageComponent),
        data: {
          showHeader: true,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['terms-and-conditions']).relativePath.join('/'),
        loadComponent: () =>
          import('./pages/terms-and-conditions/terms-and-conditions.component').then(
            (c) => c.TermAndConditionsPageComponent,
          ),
        data: {
          showHeader: true,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['privacy-policy']).relativePath.join('/'),
        loadComponent: () =>
          import('./pages/privacy-policy/privacy-policy.component').then((c) => c.PrivacyPolicyPageComponent),
        data: {
          showHeader: true,
          showFooter: true,
        } as RouteData,
      },

      {
        path: RoutePath.getPath(Path['blog']).relativePath.join('/'),
        loadComponent: () => import('./pages/blogs/blogs.component').then((c) => c.BlogsPageComponent),
        data: {
          showHeader: true,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['blog/:id']).relativePath.join('/'),
        loadComponent: () => import('./pages/blogs/blog/blog.component').then((c) => c.BlogPageComponent),
        data: {
          showHeader: true,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['email-unsubscribe']).relativePath.join('/'),
        canActivate: [emailUnsubscribeGuard],
        data: { showHeader: true, showFooter: true } as RouteData,
        loadComponent: () =>
          import('./pages/email-unsubscribe/email-unsubscribe.component').then((c) => c.EmailUnsubscribePageComponent),
      },
      {
        path: RoutePath.getPath(Path['contact-us']).relativePath.join('/'),
        loadComponent: () => import('./pages/contact/contact.component').then((c) => c.ContactUsPageComponent),
        data: {
          showHeader: true,
          headerType: HeaderType.Landing,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path.help).relativePath.join('/'),
        loadComponent: () => import('./pages/help/help.component').then((c) => c.HelpPageComponent),
        data: {
          showHeader: true,
          headerType: HeaderType.Landing,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['help/:slug']).relativePath.join('/'),
        loadComponent: () => import('./pages/help/article/article.component').then((c) => c.HelpArticlePageComponent),
        data: {
          showHeader: true,
          headerType: HeaderType.Landing,
          showFooter: true,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['chart/:id']).relativePath.join('/'),
        loadComponent: () => import('./pages/chart/chart.component').then((c) => c.ChartPageComponent),
        data: {
          headerType: HeaderType.Chart,
          showHeader: false,
          showFooter: false,
        } as RouteData,
      },
      {
        path: RoutePath.getPath(Path['back-to-stock']).relativePath.join('/'),
        loadComponent: () =>
          import('./pages/back-to-stock/back-to-stock.component').then((c) => c.BackToStockPageComponent),
        data: {
          headerType: HeaderType.Chart,
          showHeader: false,
          showFooter: false,
        } as RouteData,
      },
    ],
  },
];
